/**
 * Reads a list of ids persisted under a localStorage key, tolerating
 * unavailable or corrupt storage.
 * @param storageKey - The localStorage key holding a JSON array of ids
 * @returns The stored ids, or null when nothing usable is stored
 */
export function readStoredIds(storageKey: string): string[] | null {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) {
      return null;
    }
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return null;
    }
    return parsed.filter((id): id is string => typeof id === "string");
  } catch {
    return null;
  }
}

/**
 * Persists a list of ids under a localStorage key, ignoring storage failures.
 * @param storageKey - The localStorage key to write
 * @param ids - The ids to persist
 * @returns Nothing
 */
export function writeStoredIds(storageKey: string, ids: string[]): void {
  try {
    localStorage.setItem(storageKey, JSON.stringify(ids));
  } catch {
    return;
  }
}
